import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import Help from './pages/Help'
import Terms from './pages/Terms'
import Privacy from './pages/Privacy'
import Seo from './components/Seo'

const App: React.FC = () => {
  return (
    <div className="min-h-screen bg-background">
      <Seo />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/help" element={<Help />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
    </div>
  )
}

export default App
